import AuthService from '../../AuthService';
const Permission = {
  getPermission(page){
    return AuthService.get(`permission?page=${page}`);
  },
  showPermission(id){
    return AuthService.get(`permission/${id}`);
  },
  createPermission(data){
    return AuthService.post(`permission`,data);
  },
  updatePermission(id,data){
    return AuthService.put(`permission/${id}`,data);
  },
  deletePermission(id){
    return AuthService.delete(`permission/${id}`);
  },
  getAllPermission(){
    return AuthService.get(`permission_all`);
  },
}
export default Permission
